import { useState } from 'react';

interface ConfirmaEmailProps {
  confirmEmail: (code: string) => void
  email: string
  error?: string;
}

export const ConfirmaEmail = ({ confirmEmail, email, error }: ConfirmaEmailProps) => {
  const [code, setCode] = useState("");

  return (
    < div className="m-2  flex flex-col items-start w-full" >
      <p className='text-red-600 font-normal text-lg text-center w-full'>{error}</p>
      <p className='text-lg leading-4 my-4 text-start w-[100%]'>Digite abaixo o código que foi enviado para o email: </p>
      <strong className='text-lg leading-4 my-4 text-start'>{email}</strong>

      <form className='flex flex-col items-center my-4' >
        <input
          type="text"
          className="input-container border-2 text-gray-800 w-full"
          value={code}
          onChange={(e) => setCode(e.target.value.toLocaleUpperCase())}
        />
        <button
          type="button"
          className="mt-8 h-11 w-full rounded-lg border-0 bg-primary text-lg font-normal uppercase text-white"
          onClick={() => confirmEmail(code)}
        >Enviar</button>
      </form>

    </div >
  )

}